import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
    createRequestActionTypes,
} from '../../lib/createRequestSaga';
import * as brandAPI from '../../lib/api/brandapi';
import { takeLatest } from 'redux-saga/effects';
import { remove, forEach, indexOf, intersection } from 'lodash';
import * as prodAPI from '../../lib/api/prodapi';
import * as categoryAPI from '../../lib/api/categoryapi';

/**
 * API 서버에 Request 하는 Action Type
 */
const [
    REQ_TYPE_LIST_BRAND,
    REQ_TYPE_LIST_BRAND_SUCCESS,
    REQ_TYPE_LIST_BRAND_FAILURE,
] = createRequestActionTypes('brand/LIST_BRAND');

// 컴포넌트에서 사용할 선택된 카테고리 설정 액션
const REQ_TYPE_LIST_BRAND_SELECTED = 'brand/LIST_BRAND_SEL';

//브랜드관 ㄱ-ㅎ ㅁ-ㅎ 0-9 상태 액션
const [
    REQ_TYPE_STAT_BRAND,
    REQ_TYPE_STAT_BRAND_SUCCESS,
    REQ_TYPE_STAT_BRAND_FAILURE,
] = createRequestActionTypes('brand/STAT');

//브랜드관 브랜드와 상품 정보 요청
const [
    REQ_TYPE_INFO_BRAND,
    REQ_TYPE_INFO_BRAND_SUCCESS,
    REQ_TYPE_INFO_BRAND_FAILURE,
] = createRequestActionTypes('brand/INFO');

//브랜드관 브랜드와 상품 리스트 추가 정보 요청
const [
    REQ_TYPE_INFO_ADD_BRAND,
    REQ_TYPE_INFO_ADD_BRAND_SUCCESS,
    REQ_TYPE_INFO_ADD_BRAND_FAILURE,
] = createRequestActionTypes('brand/INFO_ADD');

//브랜드관 내가 찾는 브랜드가 없다면
const [
    REQ_TYPE_NO_BRAND,
    REQ_TYPE_NO_BRAND_SUCCESS,
    REQ_TYPE_NO_BRAND_FAILURE,
] = createRequestActionTypes('brand/NO');

//브랜드관 내가 찾는 브랜드가 없다면
const [
    REQ_TYPE_NO_ADD_BRAND,
    REQ_TYPE_NO_ADD_BRAND_SUCCESS,
    REQ_TYPE_NO_ADD_BRAND_FAILURE,
] = createRequestActionTypes('brand/NO_ADD');

//브랜드 홈 정보 
const [
    REQ_TYPE_HOME_INFO_BRAND,
    REQ_TYPE_HOME_INFO_BRAND_SUCCESS,
    REQ_TYPE_HOME_INFO_BRAND_FAILURE,
] = createRequestActionTypes('brand/HOME_INFO');

// 브랜드 클립
const [
    REQ_TYPE_USER_BRNAD_ADD,
    REQ_TYPE_USER_BRNAD_ADD_SUCCESS,
    REQ_TYPE_USER_BRNAD_ADD_FAILURE,
] = createRequestActionTypes('user/BRNAD_ADD');

const [
    REQ_TYPE_USER_BRNAD_DEL,
    REQ_TYPE_USER_BRNAD_DEL_SUCCESS,
    REQ_TYPE_USER_BRNAD_DEL_FAILURE,
] = createRequestActionTypes('user/BRAND_DEL');

// 내가 찾는 브랜드가 없다면 요청
const [
    REQ_TYPE_USER_NOBRNAD_ADD,
    REQ_TYPE_USER_NOBRNAD_ADD_SUCCESS,
    REQ_TYPE_USER_NOBRNAD_ADD_FAILURE,
] = createRequestActionTypes('user/NOBRNAD_ADD');

const [
    REQ_TYPE_USER_NOBRNAD_DEL,
    REQ_TYPE_USER_NOBRNAD_DEL_SUCCESS,
    REQ_TYPE_USER_NOBRNAD_DEL_FAILURE,
] = createRequestActionTypes('user/NOBRAND_DEL');

//브랜드 홈 상품 정보를 가져옴
const [
    REQ_TYPE_LIST_PROD_BY_BRAND_HOME2,
    REQ_TYPE_LIST_PROD_BY_BRAND_HOME2_SUCCESS,
    REQ_TYPE_LIST_PROD_BY_BRAND_HOME2_FAILURE,
] = createRequestActionTypes('brand/LIST_PROD_BY_BRAND_HOME2');

const [
    REQ_TYPE_USER_BRNAD_ALLDEL,
    REQ_TYPE_USER_BRNAD_ALLDEL_SUCCESS,
    REQ_TYPE_USER_BRNAD_ALLDEL_FAILURE
] = createRequestActionTypes('brand/REQ_TYPE_USER_BRNAD_ALLDEL');

const [
    REQ_TYPE_USER_NOBRNAD_ALLDEL,
    REQ_TYPE_USER_NOBRNAD_ALLDEL_SUCCESS,
    REQ_TYPE_USER_NOBRNAD_ALLDEL_FAILURE
] = createRequestActionTypes('brand/REQ_TYPE_USER_NOBRNAD_ALLDEL');

const [
    REQ_TYPE_BRAND_LIST_CATE3,
    REQ_TYPE_BRAND_LIST_CATE3_SUCCESS,
    REQ_TYPE_BRAND_LIST_CATE3_FAILURE,
] = createRequestActionTypes('brand/REQ_TYPE_BRAND_LIST_CATE3');

// 컴포넌트에서 사용할 선택된 변수 설정 액션
const SET_BRAND_SEL_FILTER_INDEX = 'brand/SET_BRAND_SEL_FILTER_INDEX';
// 컴포넌트에서 사용할 데이터 리셋
const SET_BRAND_SEL_DATA_RESET = 'brand/SET_BRAND_SEL_DATA_RESET';
// 브랜드 필터 인자값 저장.
const SET_BRAND_FILTER_DATA = 'brand/SET_BRAND_FILTER_DATA';

//브랜드 홈에서 카테고리 인덱스와 아이디 설정
const SET_BRAND_HOME_1ST_CATE_ID = 'brand/SET_BRAND_HOME_1ST_CATE_ID';
const SET_BRAND_HOME_1ST_CATE_INDEX = 'brand/SET_BRAND_HOME_1ST_CATE_INDEX';
const SET_BRAND_HOME_2ND_CATE_ID = 'brand/SET_BRAND_HOME_2ND_CATE_ID';
const SET_BRAND_HOME_2ND_CATE_INDEX = 'brand/SET_BRAND_HOME_2ND_CATE_INDEX';
const SET_BRAND_HOME_CUR_BRAND_ID = 'brand/SET_BRAND_HOME_CUR_BRAND_ID';
const SET_BRAND_HOME_RESET_DATA = 'brand/SET_BRAND_HOME_RESET_DATA';
//브랜드 홈에서 세번째 카테고리 정보 저장
const SET_BRAND_HOME_CHECKED_CATE = 'brand/SET_BRAND_HOME_CHECKED_CATE';
const SET_BRAND_HOME_ALL_CHECKED = 'brand/SET_BRAND_HOME_ALL_CHECKED';
const SET_BRAND_HOME_CATE_2ID_LIST = 'brand/SET_BRAND_HOME_CATE_2ID_LIST';

const SET_BRAND_HOME_ADD_DEL_CATE3 = 'brand/SET_BRAND_HOME_ADD_DEL_CATE3';
const SET_BRAND_HOME_REMOVE_DEL_CATE3 = 'brand/SET_BRAND_HOME_REMOVE_DEL_CATE3';

const SET_BRAND_HOME_RESET_DEL_CATE3 = 'brand/SET_BRAND_HOME_RESET_DEL_CATE3';

//브랜드 홈 필터 정보
const SET_BRAND_HOME_CUR_PAGE = 'brand/SET_BRAND_HOME_CUR_PAGE';
const SET_BRAND_HOME_CUR_SEL_IDS = 'brand/SET_BRAND_HOME_CUR_SEL_IDS';

const SET_BRAND_HOME_PRICE_FILTER_CHANGE = 'brand/SET_BRAND_HOME_PRICE_FILTER_CHANGE'
const SET_BRNAD_HOME_CUR_PRICE = 'brand/SET_BRNAD_HOME_CUR_PRICE'
const SET_BRNAD_HOME_CUR_MINMAX_PRICE = 'brand/SET_BRNAD_HOME_CUR_MINMAX_PRICE'

//브랜드 홈 정렬 정보 
const SET_BRAND_HOME_CUR_FILTER_ORDER = 'brand/SET_BRAND_HOME_CUR_FILTER_ORDER'

const SET_BRAND_HOME_ACTIVE_CATE_ID = 'brand/SET_BRAND_HOME_ACTIVE_CATE_ID';
const SET_BRAND_HOME_CUR_SCND_CATE_ID = 'brand/SET_BRAND_HOME_CUR_SCND_CATE_ID';


const RESET_BRAND_CLIP_RESULT = 'brand/RESET_BRAND_CLIP_RESULT'
/**
 * 견적서 요청 Action - Container 에서 요청 
 * 첫번째 인자 - ActionType
 * 두번째 인자 - 리듀서에서 처리 해야 할 Payload : 스토어에서 사용될 값 (생략가능)
 */
export const getBrandListAction = createAction(REQ_TYPE_LIST_BRAND, (cateItems) => {
    return { cateItems }
});

// 선택된 브랜드 정보 
export const setSelBrandInfoAction = createAction(REQ_TYPE_LIST_BRAND_SELECTED);
//브랜드관 ㄱ-ㅎ ㅁ-ㅎ 0-9 상태 액션 정보
export const getBrandStatInfoAction = createAction(REQ_TYPE_STAT_BRAND);
//브랜드관 브랜드와 상품 정보 (ㄱ-ㅎ ㅁ-ㅎ 0-9 )
export const getBrandInfoAction = createAction(REQ_TYPE_INFO_BRAND, (data, type, offset) => {
    return { data, type, offset }
});
//브랜드 리스트 추가
export const getBrandInfoAddAction = createAction(REQ_TYPE_INFO_ADD_BRAND, (data, type, offset) => {
    return { data, type, offset }
});
//브랜드관 내가 찾는 브랜드가 없다면 브랜드 리스트 요청
export const getBrandNoAction = createAction(REQ_TYPE_NO_BRAND, (offset) => {
    return { offset }
});
//브랜드 내가 찾는 브랜드가 없다면 브랜드 리스트 추가 요청
export const getBrandNoAddAction = createAction(REQ_TYPE_NO_ADD_BRAND, (offset) => {
    return { offset }
});

//브랜드 홈 정보 요청
export const getBrandHomeInfoAction = createAction(REQ_TYPE_HOME_INFO_BRAND, (brandId) => {
    return { brandId }
});

//브랜드 클립 추가
export const setUserBrandAddAction = createAction(REQ_TYPE_USER_BRNAD_ADD, (email, brandid) => {
    return { email, brandid }
});

//브랜드 클립 삭제
export const setUserBrandDelAction = createAction(REQ_TYPE_USER_BRNAD_DEL, (email, brandid) => {
    return { email, brandid }
});
export const setUserNoBrandDelAction = createAction(REQ_TYPE_USER_NOBRNAD_DEL, (email, brandid) => {
    return { email, brandid }
});

//브랜드 클립 모두 삭제
export const setUserBrandAllDelAction = createAction(REQ_TYPE_USER_BRNAD_ALLDEL);
export const setUserNoBrandAllDelAction = createAction(REQ_TYPE_USER_NOBRNAD_ALLDEL);

// 내가 찾는 브랜드가 없다면 요청
export const setUserNoBrandAddAction = createAction(REQ_TYPE_USER_NOBRNAD_ADD, (email, nobrandid) => {
    return { email, nobrandid }
});
//클립 결과 리셋
export const setReSetBrandClipResultAction = createAction(RESET_BRAND_CLIP_RESULT);

// 선택된 filter index 설절
export const setBrandSelFilterIndexAction = createAction(SET_BRAND_SEL_FILTER_INDEX);
export const setBrandSelDataResetAction = createAction(SET_BRAND_SEL_DATA_RESET);
//선택된 filter 데이터 저장
export const setSetBrandFilterDataAction = createAction(SET_BRAND_FILTER_DATA);

//브랜드 홈 케테고리 인덱스와 아이디 설정
export const setSetBrandHome1stCateIdAction = createAction(SET_BRAND_HOME_1ST_CATE_ID);
export const setSetBrandHome1stCateIndexAction = createAction(SET_BRAND_HOME_1ST_CATE_INDEX);
export const setSetBrandHome2ndCateIdAction = createAction(SET_BRAND_HOME_2ND_CATE_ID);
export const setSetBrandHome2ndCateIndexAction = createAction(SET_BRAND_HOME_2ND_CATE_INDEX);
export const setSetBrandHomeCurBrandIdAction = createAction(SET_BRAND_HOME_CUR_BRAND_ID);
export const setSetBrandHomeResetDataAction = createAction(SET_BRAND_HOME_RESET_DATA);
export const setSetBrandHomeCheckedCateAction = createAction(SET_BRAND_HOME_CHECKED_CATE);
export const setSetBrandHomeAllCheckedAction = createAction(SET_BRAND_HOME_ALL_CHECKED);
export const setSetBrandHomeCate2IdListAction = createAction(SET_BRAND_HOME_CATE_2ID_LIST);
export const setSetBrandHomeCurPageAction = createAction(SET_BRAND_HOME_CUR_PAGE);
export const setSetBrandHomeCurSelIdsAction = createAction(SET_BRAND_HOME_CUR_SEL_IDS);

// 3depth 선택 제외 카테고리 저장 
export const BrandHomeAddDelCate3ListAction = createAction(SET_BRAND_HOME_ADD_DEL_CATE3);
export const BrandHomeRemovelCate3ListAction = createAction(SET_BRAND_HOME_REMOVE_DEL_CATE3);

export const setReSetDelCate3IdAction = createAction(SET_BRAND_HOME_RESET_DEL_CATE3);

//브랜드 홈 가격필터 변동 여부 체크
export const setSetBrandHomePriceFilterChangeAction = createAction(SET_BRAND_HOME_PRICE_FILTER_CHANGE);
export const setSetBrandHomeCurPriceAction = createAction(SET_BRNAD_HOME_CUR_PRICE);
export const setSetBrandHomeCurMinMaxPriceAction = createAction(SET_BRNAD_HOME_CUR_MINMAX_PRICE);

//브랜드 홈 정렬 정보 
export const setSetBrandHomeCurFilterOrder = createAction(SET_BRAND_HOME_CUR_FILTER_ORDER);

export const setSetBrandHomeActiveCateIdAction = createAction(SET_BRAND_HOME_ACTIVE_CATE_ID);
export const setSetBrandHomeCurScndCateIdAction = createAction(SET_BRAND_HOME_CUR_SCND_CATE_ID);

//브랜드 상품 정보 저장위치 분리
export const getBrandHomeProdsAction2 = createAction(REQ_TYPE_LIST_PROD_BY_BRAND_HOME2, (cateId, brandId, filterItems, curPage, minprice, maxprice, sort) => {
    return ({ cateId, brandId, filterItems, curPage, minprice, maxprice, sort })
}
);

export const getBrandCate3ListAction = createAction(REQ_TYPE_BRAND_LIST_CATE3, (curSelCateId) => ({ curSelCateId }));
/**
 * SAGA API 에서 REST API 호출 
 */
const listBrandItemsSaga = createRequestSaga(REQ_TYPE_LIST_BRAND, brandAPI.getBrandListByCateId);
const listBrandStatSaga = createRequestSaga(REQ_TYPE_STAT_BRAND, brandAPI.getBrandStat);
const listBrandInfoSaga = createRequestSaga(REQ_TYPE_INFO_BRAND, brandAPI.getBrandInfo);
const listBrandInfoAddSaga = createRequestSaga(REQ_TYPE_INFO_ADD_BRAND, brandAPI.getBrandInfo);
const listBrandNoBrandSaga = createRequestSaga(REQ_TYPE_NO_BRAND, brandAPI.getNoBrandInfo);
const listBrandNoAddBrandSaga = createRequestSaga(REQ_TYPE_NO_ADD_BRAND, brandAPI.getNoBrandInfo);
const listBrandHomeInfoSaga = createRequestSaga(REQ_TYPE_HOME_INFO_BRAND, brandAPI.getBrandHomeInfo);
//브랜드 클립 추가
const brandAddSaga = createRequestSaga(REQ_TYPE_USER_BRNAD_ADD, brandAPI.brandAdd);
const brandDelSaga = createRequestSaga(REQ_TYPE_USER_BRNAD_DEL, brandAPI.brandDel);
const nobrandAddSaga = createRequestSaga(REQ_TYPE_USER_NOBRNAD_ADD, brandAPI.nobrandAdd);
const nobrandDelSaga = createRequestSaga(REQ_TYPE_USER_NOBRNAD_DEL, brandAPI.nobrandDel);

const dellAllBrandClipSaga = createRequestSaga(REQ_TYPE_USER_BRNAD_ALLDEL, brandAPI.allDelBrand);
const dellAllNoBrandClipSaga = createRequestSaga(REQ_TYPE_USER_NOBRNAD_ALLDEL, brandAPI.allDelNoBrand);

const brandHomeProdsSaga2 = createRequestSaga(REQ_TYPE_LIST_PROD_BY_BRAND_HOME2, prodAPI.getBrandHomeProds);
const listCate3ItemsSaga = createRequestSaga(REQ_TYPE_BRAND_LIST_CATE3, categoryAPI.get3DepCategory);

export function* brandItemsSaga() {
    yield takeLatest(REQ_TYPE_LIST_BRAND, listBrandItemsSaga);
    yield takeLatest(REQ_TYPE_STAT_BRAND, listBrandStatSaga);
    yield takeLatest(REQ_TYPE_INFO_BRAND, listBrandInfoSaga);
    yield takeLatest(REQ_TYPE_INFO_ADD_BRAND, listBrandInfoAddSaga);
    yield takeLatest(REQ_TYPE_NO_BRAND, listBrandNoBrandSaga);
    yield takeLatest(REQ_TYPE_NO_ADD_BRAND, listBrandNoAddBrandSaga);
    yield takeLatest(REQ_TYPE_HOME_INFO_BRAND, listBrandHomeInfoSaga);
    yield takeLatest(REQ_TYPE_USER_BRNAD_ADD, brandAddSaga);
    yield takeLatest(REQ_TYPE_USER_BRNAD_DEL, brandDelSaga);
    yield takeLatest(REQ_TYPE_USER_NOBRNAD_ADD, nobrandAddSaga);
    yield takeLatest(REQ_TYPE_USER_NOBRNAD_DEL, nobrandDelSaga);
    yield takeLatest(REQ_TYPE_LIST_PROD_BY_BRAND_HOME2, brandHomeProdsSaga2);
    yield takeLatest(REQ_TYPE_USER_BRNAD_ALLDEL, dellAllBrandClipSaga);
    yield takeLatest(REQ_TYPE_USER_NOBRNAD_ALLDEL, dellAllNoBrandClipSaga);
    yield takeLatest(REQ_TYPE_BRAND_LIST_CATE3, listCate3ItemsSaga);
}

 
/**
 * Store에 저장될 값 
 */
const initialState = {
    brandItems: null,
    selectedBrandItem: {
        id: 0,
        brnd_han: null, brnd_logo_url: '', brnd_thumb_url: '', brnd_desc: ''
    },
    brandStat: null,             //브랜드 필터 정보 ㄱ,a, 0-9 등
    brandInfo: null,             //브랜드 정보리스트들 저장
    brandSelFilterIndex: -1,     //브랜드 선택된 필터 인덱스
    brandSelFilterData: null,    //브랜드 선택된 필터 데이터 저장 (data,type,offset)
    brandNoItem: null,           //브랜드가 없다면 리스트 저장
    brandClipResult: null,       //브랜드 클립(좋아요) 결과
    brandNoAddResult: null,       //브랜드가 없다면 추가 결과

    brandClipAllDelResult: null,       //크립 브랜드 모두 삭제 결과

    brandHomeInfo: null,         //브랜드 홈 정보 저장
    cur1stCateId: 0,             //브랜드 홈 첫번째 카테고리 아이디
    curFirstIndex: -1,            //브랜드 홈 첫번째 카테고리의 인덱스
    cur2ndCateId: 0,             //브랜드 홈 두번째 카테고리 아이디
    curBrandId: -1,              //브랜드 홈 현재 브랜드 아이디
    curSecondIndex: -1,           //브랜드 홈 두번째 카테고리의 인덱스

    checkedCate: [],             //브랜드 홈 세번째 카테고리 정보
    allChecked: false,           //브랜드 홈 세번째 카테고리 정보
    cate2IdList: [],             //브랜드 홈 세번째 카테고리 정보
    delCate3Ids: [],            // 제외되는 3 depth 카테고리 

    priceFilterChange: false,    //브랜드 홈 가격 필터 변동 여부 체크
    curPrice: [0, 0],             //브랜드 가격 필터 현재 가격
    curMinMaxPrice: [0, 0],       //브랜드 가격 필터 최대/최소 가격

    curFilterOrder: 0,           //최신순/인기순/낮은가격순/높은 가격순 정렬

    curPageNum: 1,               //상품 페이지 표시
    curSelIds: [],               //상품 필터 정보

    curSelScndCateId: null,     // 3depth 항목을 가져오기 위한 단일 2depth cateId
    activeCateIds: [],          // 3depth 카테고리 선택 저장 

    prodItems: null,            // 상품 정보
    cate3depItems: null,
    cateExist: [],
    error: null
}

const brandItemsReducer = handleActions(
    {
        [REQ_TYPE_LIST_BRAND_SUCCESS]: (state, { payload: brandItems }) => {
            // console.log("success : " + JSON.stringify(brandItems));
            return ({
                ...state,
                brandItems,
            })
        },
        [REQ_TYPE_LIST_BRAND_FAILURE]: (state, { payload: error }) => {
            // console.log("error : " + JSON.stringify(error));
            return ({
                ...state,
                error,
            })
        },
        [REQ_TYPE_LIST_BRAND_SELECTED]: (state, { payload: selectedBrandItem }) => ({
            ...state,
            selectedBrandItem,
        }),
        [REQ_TYPE_STAT_BRAND_SUCCESS]: (state, { payload: brandStat }) => {
            // console.log("REQ_TYPE_STAT_BRAND_SUCCESS");
            return ({

                ...state,
                error: null,
                brandStat: brandStat,
            })
        },
        [REQ_TYPE_STAT_BRAND_FAILURE]: (state, { payload: error }) => {
            // console.log("REQ_TYPE_STAT_BRAND_FAILURE : " + JSON.stringify(error));
            return ({
                ...state,
                error: error,
            })
        },
        [REQ_TYPE_INFO_BRAND_SUCCESS]: (state, { payload: brandInfo }) => {
            // console.log("REQ_TYPE_INFO_BRAND_SUCCESS");
            return ({

                ...state,
                error: null,
                brandInfo: brandInfo,
            })
        },
        [REQ_TYPE_INFO_BRAND_FAILURE]: (state, { payload: error }) => {
            // console.log("REQ_TYPE_INFO_BRAND_FAILURE : " + JSON.stringify(error));
            return ({
                ...state,
                error: error,
            })
        },
        [SET_BRAND_SEL_FILTER_INDEX]: (state, { payload: brandSelFilterIndex }) => {
            // console.log("SET_BRAND_SEL_FILTER_INDEX");
            return ({
                ...state,
                brandSelFilterIndex: brandSelFilterIndex,
            })
        },
        [REQ_TYPE_INFO_ADD_BRAND_SUCCESS]: (state, { payload: brandInfo }) => {
            // console.log("REQ_TYPE_INFO_ADD_BRAND_SUCCESS");

            let dataList = state.brandInfo.dataList.concat(brandInfo.dataList);

            let data = Object.assign({}, state.brandInfo);
            data.dataList = [];
            Object.assign(data.dataList, dataList);

            return ({

                ...state,
                error: null,
                brandInfo: data,
            })
        },
        [REQ_TYPE_INFO_ADD_BRAND_FAILURE]: (state, { payload: error }) => {
            // console.log("REQ_TYPE_INFO_ADD_BRAND_FAILURE : " + JSON.stringify(error));
            return ({
                ...state,
                error: error,
            })
        },
        [SET_BRAND_FILTER_DATA]: (state, { payload: brandSelFilterData }) => {
            // console.log("SET_BRAND_FILTER_DATA");
            return ({
                ...state,
                brandSelFilterData: brandSelFilterData,
            })
        },
        [REQ_TYPE_NO_BRAND_SUCCESS]: (state, { payload: brandNoItem }) => {
            // console.log("REQ_TYPE_NO_BRAND_SUCCESS");
            return ({

                ...state,
                error: null,
                brandNoItem: brandNoItem,
            })
        },
        [REQ_TYPE_NO_BRAND_FAILURE]: (state, { payload: error }) => {
            // console.log("REQ_TYPE_NO_BRAND_FAILURE : " + JSON.stringify(error));
            return ({
                ...state,
                error: error,
            })
        },
        [REQ_TYPE_NO_ADD_BRAND_SUCCESS]: (state, { payload: brandNoItem }) => {
            // console.log("REQ_TYPE_NO_ADD_BRAND_SUCCESS");

            let dataList = state.brandNoItem.concat(brandNoItem);

            //let data = Object.assign({}, dataList);
            //data.dataList = [];
            //Object.assign(data.dataList, dataList);

            return ({

                ...state,
                error: null,
                brandNoItem: dataList,
            })
        },
        [REQ_TYPE_NO_ADD_BRAND_FAILURE]: (state, { payload: error }) => {
            // console.log("REQ_TYPE_NO_ADD_BRAND_FAILURE : " + JSON.stringify(error));
            return ({
                ...state,
                error: error,
            })
        },
        [REQ_TYPE_HOME_INFO_BRAND_SUCCESS]: (state, { payload: brandHomeInfo }) => {
            // console.log("REQ_TYPE_HOME_INFO_BRAND_SUCCESS");
            let cateData = brandHomeInfo.numCatePrdct;
            let cateArray = [];
            if(cateData !== null && cateData !== undefined){
                cateData.forEach(cate1 => {
                    let cate2bucket = cate1.cate2.buckets;
                    cate2bucket.forEach(cate2 => {
                        let cate3bucket = cate2.cate3.buckets;
                        cate3bucket.forEach(cate3 => {
                            let cate = cate1.key*10000+cate2.key*100+cate3.key;
                            cateArray.push(cate);
                        });
                    });

                });

            }

            return ({

                ...state,
                error: null,
                brandHomeInfo: brandHomeInfo,
                cateExist:cateArray,
            })
        },
        [REQ_TYPE_HOME_INFO_BRAND_FAILURE]: (state, { payload: error }) => {
            // console.log("REQ_TYPE_HOME_INFO_BRAND_FAILURE : " + JSON.stringify(error));
            return ({
                ...state,
                error: error,
            })
        },


        [REQ_TYPE_USER_BRNAD_ADD_SUCCESS]: (state, { payload: brandClipResult }) => {
            // console.log("REQ_TYPE_USER_BRNAD_ADD_SUCCESS");
            return ({

                ...state,
                error: null,
                brandClipResult: brandClipResult,
            })
        },
        [REQ_TYPE_USER_BRNAD_ADD_FAILURE]: (state, { payload: error }) => {
            // console.log("REQ_TYPE_USER_BRNAD_ADD_FAILURE : " + JSON.stringify(error));
            return ({
                ...state,
                error: error,
            })
        },

        [REQ_TYPE_USER_BRNAD_DEL_SUCCESS]: (state, { payload: brandClipResult }) => {
            // console.log("REQ_TYPE_USER_BRNAD_DEL_SUCCESS");
            return ({

                ...state,
                error: null,
                brandClipResult: brandClipResult,
            })
        },
        [REQ_TYPE_USER_BRNAD_DEL_FAILURE]: (state, { payload: error }) => {
            // console.log("REQ_TYPE_USER_BRNAD_DEL_FAILURE : " + JSON.stringify(error));
            return ({
                ...state,
                error: error,
            })
        },
        [REQ_TYPE_USER_NOBRNAD_ADD_SUCCESS]: (state, { payload: brandNoAddResult }) => {
            // console.log("REQ_TYPE_USER_NOBRNAD_ADD_SUCCESS");
            return ({

                ...state,
                error: null,
                brandNoAddResult: brandNoAddResult,
            })
        },
        [REQ_TYPE_USER_NOBRNAD_ADD_FAILURE]: (state, { payload: error }) => {
            // console.log("REQ_TYPE_USER_NOBRNAD_ADD_FAILURE : " + JSON.stringify(error));
            return ({
                ...state,
                error: error,
            })
        },
        [REQ_TYPE_USER_NOBRNAD_DEL_SUCCESS]: (state, { payload: brandClipResult }) => {
            // console.log("REQ_TYPE_USER_BRNAD_DEL_SUCCESS");
            return ({

                ...state,
                error: null,
                brandClipResult: brandClipResult,
            })
        },
        [REQ_TYPE_USER_NOBRNAD_DEL_FAILURE]: (state, { payload: error }) => {
            // console.log("REQ_TYPE_USER_BRNAD_DEL_FAILURE : " + JSON.stringify(error));
            return ({
                ...state,
                error: error,
            })
        },
        [SET_BRAND_HOME_1ST_CATE_ID]: (state, { payload: cur1stCateId }) => {
            // console.log("SET_BRAND_HOME_1ST_CATE_ID");
            return ({
                ...state,
                cur1stCateId: cur1stCateId,
            })
        },
        [SET_BRAND_HOME_1ST_CATE_INDEX]: (state, { payload: curFirstIndex }) => {
            // console.log("SET_BRAND_HOME_1ST_CATE_INDEX");
            return ({
                ...state,
                curFirstIndex: curFirstIndex,
            })
        },
        [SET_BRAND_HOME_2ND_CATE_ID]: (state, { payload: cur2ndCateId }) => {
            // console.log("SET_BRAND_HOME_2ND_CATE_ID");
            return ({
                ...state,
                cur2ndCateId: cur2ndCateId,
            })
        },
        [SET_BRAND_HOME_2ND_CATE_INDEX]: (state, { payload: curSecondIndex }) => {
            // console.log("SET_BRAND_HOME_2ND_CATE_INDEX");
            return ({
                ...state,
                curSecondIndex: curSecondIndex,
            })
        },
        [SET_BRAND_HOME_CUR_BRAND_ID]: (state, { payload: curBrandId }) => {
            // console.log("SET_BRAND_HOME_CUR_BRAND_ID");
            return ({
                ...state,
                curBrandId: curBrandId,
            })
        },
        [SET_BRAND_HOME_CHECKED_CATE]: (state, { payload: checkedCate }) => {
            // console.log("SET_BRAND_HOME_CHECKED_CATE");
            return ({
                ...state,
                checkedCate: checkedCate,
            })
        },
        [SET_BRAND_HOME_ALL_CHECKED]: (state, { payload: allChecked }) => {
            // console.log("SET_BRAND_HOME_ALL_CHECKED");
            return ({
                ...state,
                allChecked: allChecked,
            })
        },
        [SET_BRAND_HOME_CATE_2ID_LIST]: (state, { payload: cate2IdList }) => {
            // console.log("SET_BRAND_HOME_CATE_2ID_LIST");
            return ({
                ...state,
                cate2IdList: cate2IdList,
            })
        },
        [SET_BRAND_HOME_CUR_PAGE]: (state, { payload: curPageNum }) => {
            // console.log("SET_BRAND_HOME_CUR_PAGE");
            return ({
                ...state,
                curPageNum: curPageNum,
            })
        },
        [SET_BRAND_HOME_CUR_SEL_IDS]: (state, { payload: curSelIds }) => {
            // console.log("SET_BRAND_HOME_CUR_SEL_IDS");
            return ({
                ...state,
                curSelIds: curSelIds,
            })
        },
        [SET_BRAND_HOME_PRICE_FILTER_CHANGE]: (state, { payload: priceFilterChange }) => {
            // console.log("SET_BRAND_HOME_PRICE_FILTER_CHANGE");
            return ({
                ...state,
                priceFilterChange: priceFilterChange,
            })
        },
        [SET_BRNAD_HOME_CUR_PRICE]: (state, { payload: curPrice }) => {
            // console.log("SET_BRNAD_HOME_CUR_PRICE");
            return ({
                ...state,
                curPrice: curPrice,
            })
        },
        [SET_BRNAD_HOME_CUR_MINMAX_PRICE]: (state, { payload: curMinMaxPrice }) => {
            // console.log("SET_BRNAD_HOME_CUR_MINMAX_PRICE");
            return ({
                ...state,
                curMinMaxPrice: curMinMaxPrice,
            })
        },
        [SET_BRAND_HOME_CUR_FILTER_ORDER]: (state, { payload: curFilterOrder }) => {
            // console.log("SET_BRAND_HOME_CUR_FILTER_ORDER");
            return ({
                ...state,
                curFilterOrder: curFilterOrder,
            })
        },
        [SET_BRAND_HOME_ADD_DEL_CATE3]: (state, { payload: cateid }) => {

            // console.log("set Acive Cate ID")
            let srcIds = state.delCate3Ids;
            let idx = indexOf(srcIds, cateid);
            if (idx === -1) {
                srcIds.push(cateid);
            }

            // activeCateIds 에서는 제거 해야 함
            let activeIds = state.activeCateIds;
            idx = indexOf(activeIds, cateid);
            remove(activeIds, (curitem) => { return (curitem === cateid) })

            return ({
                ...state
            })
        },
        [SET_BRAND_HOME_REMOVE_DEL_CATE3]: (state, { payload: cateid }) => {

            // console.log("set Acive Cate ID")
            // 전체 삭제 
            if (cateid === -1) {
                return ({
                    ...state,
                    delCate3Ids: []
                })
            } else {
                // console.log("set Acive Cate ID")
                let srcIds = state.delCate3Ids;
                remove(srcIds, (curitem) => {
                    return (curitem === cateid)
                })

                // activeCateIds 에서는 추가 해야 함
                let activeIds = state.activeCateIds;
                let idx = indexOf(activeIds, cateid);
                if (idx === -1) {
                    activeIds.push(cateid);
                }

                return ({
                    ...state
                })
            }
        },
        [SET_BRAND_HOME_ACTIVE_CATE_ID]: (state, { payload: activeCateIds }) => {

            // console.log("set Acive Cate ID")
            // 추가된 cate id 가 Del 배열에 있으면 삭제 배열에서 삭제 처리
            let dupCateIds = intersection(state.delCate3Ids, activeCateIds);
            // console.log("dupCateIds : " + dupCateIds);

            if (dupCateIds !== null) {
                dupCateIds.forEach(element => {
                    remove(state.delCate3Ids, (curitem) => {
                        return curitem === element;
                    });
                });
            }

            return ({
                ...state,
                activeCateIds: activeCateIds
            })

        },
        [SET_BRAND_HOME_CUR_SCND_CATE_ID]: (state, { payload: curSelCateId }) => ({
            ...state,
            curSelScndCateId: curSelCateId,
        }),
        [REQ_TYPE_LIST_PROD_BY_BRAND_HOME2_SUCCESS]: (state, { payload: prodItems }) => {
            // 요청이 왔는데, curpage 
            return ({
                ...state,
                prodItems,
            });
        },
        [REQ_TYPE_LIST_PROD_BY_BRAND_HOME2_FAILURE]: (state, { payload: error }) => {
            // console.log("error : " + JSON.stringify(error));
            return ({
                ...state,
                error,
            });
        },
        [SET_BRAND_HOME_RESET_DATA]: (state) => {
            // console.log("SET_BRAND_HOME_RESET_DATA");
            return ({
                ...state,
                brandHomeInfo: null,         //브랜드 홈 정보 저장
                cur1stCateId: 0,             //브랜드 홈 첫번째 카테고리 아이디
                curFirstIndex: -1,            //브랜드 홈 첫번째 카테고리의 인덱스
                cur2ndCateId: 0,             //브랜드 홈 두번째 카테고리 아이디
                curBrandId: -1,              //브랜드 홈 현재 브랜드 아이디
                curSecondIndex: -1,           //브랜드 홈 두번째 카테고리의 인덱스
                checkedCate: [],             //브랜드 홈 세번째 카테고리 정보
                allChecked: false,           //브랜드 홈 세번째 카테고리 정보
                cate2IdList: [],             //브랜드 홈 세번째 카테고리 정보
                delCate3Ids: [],            // 제외되는 3 depth 카테고리 
                curPageNum: 1,               //상품 페이지 표시
                curSelIds: [],               //상품 필터 정보
                priceFilterChange: false,    //브랜드 홈 가격 필터 변동 여부 체크
                curPrice: [0, 0],             //브랜드 가격 필터 현재 가격
                curMinMaxPrice: [0, 0],       //브랜드 가격 필터 최대/최소 가격
                curFilterOrder: 0,           //최신순/인기순/낮은가격순/높은 가격순 정렬
                curSelScndCateId: null,     // 3depth 항목을 가져오기 위한 단일 2depth cateId
                activeCateIds: [],          // 3depth 카테고리 선택 저장 
                prodItems: null,            // 상품 정보
                cate3depItems: null,
                cateExist: [],
            })
        },
        [SET_BRAND_SEL_DATA_RESET]: (state) => {
            // console.log("SET_BRAND_SEL_DATA_RESET");
            return ({
                ...state,
                brandStat: null,             //브랜드 필터 정보 ㄱ,a, 0-9 등
                brandInfo: null,             //브랜드 정보리스트들 저장
                brandSelFilterIndex: -1,     //브랜드 선택된 필터 인덱스
                brandSelFilterData: null,    //브랜드 선택된 필터 데이터 저장 (data,type,offset)
                brandNoItem: null,           //브랜드가 없다면 리스트 저장
                brandHomeInfo: null,         //브랜드 홈 정보 저장
                error: null
            })
        },
        [REQ_TYPE_USER_BRNAD_ALLDEL_SUCCESS]: (state, { payload }) => {
            return ({
                ...state,
                brandClipAllDelResult: payload
            });
        },
        [REQ_TYPE_USER_NOBRNAD_ALLDEL_SUCCESS]: (state, { payload }) => {
            return ({
                ...state,
                brandClipAllDelResult: payload
            });
        },
        [SET_BRAND_HOME_RESET_DEL_CATE3]: (state) => {
            return ({
                ...state,
                delCate3Ids: [],
            });
        },
        [RESET_BRAND_CLIP_RESULT]: (state) => {
            return ({
                ...state,
                brandClipResult: null,
                brandClipAllDelResult: null,
            });
        },
        [REQ_TYPE_BRAND_LIST_CATE3_SUCCESS]: (state, { payload: cate3depItems }) => {
            let target = [];
            cate3depItems.map((cateitem) => {
                const cateid = (cateitem.cate1_id * 10000) + (cateitem.cate2_id * 100) + cateitem.cate3_id;
                if(state.cateExist === null || state.cateExist === undefined || state.cateExist.length === 0){
                    target.push(cateitem);
                }else{
                    for(let i = 0 ; i < state.cateExist.length; i++){
                        let cate2 = state.cateExist[i];
                        let cate2_t = cateid;
                        if(cate2 === cate2_t){
                            target.push(cateitem);
                            break;
                        }
                    }
                }
            })

            return ({
                ...state,
                cate3depItems:target,
            })
        },
        [REQ_TYPE_BRAND_LIST_CATE3_FAILURE]: (state, { payload: error }) => ({
            ...state,
            error,
        }),
    }
    , initialState);

export default brandItemsReducer;
